import PropTypes from 'prop-types';
import React from 'react';
import { Trans } from '@lingui/macro';
import NavMokaLogo from './NavMokaLogo';
import NavNotLoggedIn from './NavNotLoggedIn';
import styles from './style.css';

class Nav extends React.Component {
  shouldComponentUpdate(nextProps) {
    const { location, isMokaOpenApiRedirect } = this.props;
    if (location.pathname !== nextProps.location.pathname) {
      return true;
    }
    if (isMokaOpenApiRedirect !== nextProps.isMokaOpenApiRedirect) {
      return true;
    }

    return false;
  }

  render() {
    const { isMokaOpenApiRedirect, location } = this.props;

    return (
      <nav
        className={`navbar mk-navbar ${styles['navbar-moka']}`}
        role="navigation"
      >
        <div className="container">
          <div
            className={`col-xs-3 col-md-1 col-image ${styles['logo-wrapper']}`}
          >
            <NavMokaLogo
              link="/login"
              isMokaOpenApiRedirect={isMokaOpenApiRedirect}
            />
          </div>
          <div className="col-xs-offset-6 col-xs-3 visible-sm visible-xs">
            <button
              className="navbar-toggle navbar-toggle-always"
              data-toggle="collapse"
              data-target="#NavNotLoggedIn"
              aria-controls="NavNotLoggedIn"
              aria-expanded="false"
              type="button"
            >
              <span className="sr-only">
                <Trans>Menu</Trans>
              </span>
              <span className="icon-bar" />
              <span className="icon-bar" />
              <span className="icon-bar" />
            </button>
          </div>
          {!isMokaOpenApiRedirect && (
            <div
              className={`col-xs-12 col-md-11 col-menu ${
                styles['navbar-wrapper']
              }`}
            >
              <NavNotLoggedIn location={location} />
            </div>
          )}
        </div>
      </nav>
    );
  }
}

Nav.propTypes = {
  isMokaOpenApiRedirect: PropTypes.bool,
};

export default Nav;
